import { getScrollContainer } from '@theme/scroll-container';

/**
 * Horizon's own scroll-container.js (core, untouched) restores scroll
 * position on `pageshow` when `history.state.scrollTop` is set — correct
 * for back/forward navigation, where landing back where the user left off
 * is the point. A genuinely fresh navigation (clicking a link to a new
 * page) should always start at the top instead.
 *
 * `event.persisted` is the reliable signal here — true only for a bfcache
 * restore (back/forward), false for every other navigation, including the
 * native cross-document view transitions this theme has on by default
 * (base.css `@view-transition { navigation: auto }`). Only acts when
 * Horizon's own restore wouldn't have kicked in anyway (no saved
 * scrollTop), so it never fights the legitimate back/forward case.
 */
window.addEventListener('pageshow', (event) => {
  if (event.persisted) return;
  if (history.state?.scrollTop != null) return;

  getScrollContainer().scrollTo({ top: 0, behavior: 'instant' });
});
